import { render, staticRenderFns } from "./pintuan.vue?vue&type=template&id=50f81bd2&"
import script from "./pintuan.vue?vue&type=script&lang=js&"
export * from "./pintuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports